<template>
  <div class="animated fadeIn pt-1">
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-4"
        />
      </b-col>
    </b-row>
    <div v-else>
      <b-row>
        <b-col md="6">
          <h3>Order Management</h3>
        </b-col>
        <b-col md="3">
          <eb-select
            type="select"
            style="font-size: 12px; font-weight: 600"
            v-model="selectStatusOption"
            :options="statusOptions"
            label="text"
            :id="'selecttime'"
            :placeholder="'Status'"
            @input="onStatusChange"
            :selected="selectStatusOption"
          ></eb-select>
        </b-col>
        <b-col md="2">
          <eb-select
            v-if="hideSelect"
            type="select"
            style="font-size: 12px; font-weight: 600"
            v-model="selectedDurationOption"
            :options="durationOptions"
            label="text"
            :id="'selectduration'"
            :placeholder="'Time Duration'"
            :selected="selectedDurationOption.text"
            @input="changeDuration"
          ></eb-select>
          <c-date
            ref="compRefs"
            modalRef="modalRef"
            modalId="dateModal1"
            @customDateRange="findDateResult"
          ></c-date>
        </b-col>
        <b-col md="1">
          <b-button
            size="sm"
            variant="success"
            @click="reloadData"
            :disabled="loading"
          >
            <span
              v-if="loading"
              class="fa fa-refresh fa-spin"
              style="font-size: 15px"
            />
            <span v-else class="fa fa-refresh" style="font-size: 15px" />
          </b-button>
        </b-col>
      </b-row>
      <b-card border-variant="info" class="radius">
        <b-row class="mt-3" v-if="showFilter">
          <b-col md="2">
            <h4 class="ml-2">Advance Filter</h4>
          </b-col>
          <b-col md="2">
            <eb-select
              type="select"
              class="dropdown"
              v-model="selectedSellerOption"
              :options="sellerOptions"
              label="text"
              :id="'selectseller'"
              :placeholder="'Seller'"
              @input="onSellerChange"
              :selected="selectedSellerOption"
            ></eb-select>
          </b-col>
          <b-col md="2">
            <eb-select
              type="select"
              class="dropdown w-100"
              v-model="selectedSearchOption"
              :options="searchOptionsData"
              label="text"
              :id="'searchby'"
              placeholder="Select Search Criteria"
              :selected="selectedSearchOption"
              @input="onSearchChange"
            ></eb-select>
          </b-col>
          <b-col md="3" v-if="this.show">
            <div>
              <b-form-input
                class="searchField mr-sm-2"
                :placeholder="`${
                  this.show ? this.selectedSearchOption.text : 'Enter Order #'
                }`"
                v-model="searchQuery"
                @keyup.enter="getOrderList"
              ></b-form-input>
              <eb-button
                class="searchIcon"
                classic="btn-light"
                text=""
                icon="fa fa-search"
                iconSide="right"
                :disabled="searchQuery == ''"
                @click="getOrderList"
              ></eb-button>
            </div>
          </b-col>
          <b-col v-if="showdropdown">
            <eb-select
              type="select"
              class="dropdown w-100"
              v-model="selectedOptionSearch"
              :options="searchOrderOptions"
              label="text"
              :id="'searchby'"
              placeholder="Select Search Criteria"
              :selected="selectedOptionSearch"
              @input="onSearchChange"
            ></eb-select>
          </b-col>
          <b-col>
            <h4 class="reset" @click="resetFilter">Reset Filter</h4>
          </b-col>
          <b-col>
            <b-button
              class="export-btn"
              size="sm"
              variant="success"
              @click="exportData"
            >
              <i class="fa fa-download"></i>
              <span class="ml-1">Export Order</span>
            </b-button>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col md="3">
            <eb-select
              type="select"
              class="dropdown"
              v-model="selectedSearchOption"
              :options="searchOptionsData"
              label="text"
              :id="'searchby'"
              placeholder="Select Search Criteria"
              :selected="selectedSearchOption"
              @input="onSearchChange"
            ></eb-select>
          </b-col>
          <b-col md="4" v-if="this.show">
            <div>
              <b-form-input
                class="searchField mr-sm-2"
                :placeholder="`${
                  this.show ? this.selectedSearchOption.text : 'Enter Order #'
                }`"
                v-model="searchQuery"
                @keyup.enter="getOrderList"
              ></b-form-input>
              <eb-button
                class="searchIcon"
                classic="btn-light"
                text=""
                icon="fa fa-search"
                iconSide="right"
                :disabled="searchQuery == ''"
                @click="getOrderList"
              ></eb-button>
            </div>
          </b-col>
          <b-col v-if="showdropdown">
            <eb-select
              type="select"
              class="dropdown"
              v-model="selectedOptionSearch"
              :options="searchOrderOptions"
              label="text"
              :id="'searchby'"
              placeholder="Select Search Criteria"
              :selected="selectedOptionSearch"
              @input="onSearchChange"
            ></eb-select>
          </b-col>
          <b-col>
            <h4 class="reset" @click="resetFilter">Reset Filter</h4>
          </b-col>
        </b-row>
        <hr />
        <b-table
          :dark="dark"
          :hover="hover"
          :striped="striped"
          :bordered="bordered"
          :small="small"
          :fixed="fixed"
          responsive
          :items="orderList"
          :fields="captions"
          :per-page="perPage"
          :filter="filter"
          thead-class="header"
          show-empty
          class="mt-3 radius"
          :no-border-collapse="true"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template slot="empty">
            <div v-if="disableSellerKey" class="text-center">
              <span><b>Loading...</b></span>
            </div>
            <div v-else class="text-center">No data available.</div>
          </template>
          <template slot="customerPhone" slot-scope="data">
            {{
              getDeliveryContact(
                (data &&
                  data.item &&
                  data.item.deliveryAddress &&
                  data.item.deliveryAddress.address &&
                  data.item.deliveryAddress.address.contacts) ||
                  ""
              )
            }}
          </template>
          <template slot="action" slot-scope="data">
            <b-button
              size="sm"
              class="mr-2 button-circle"
              variant="primary"
              @click="viewOrderDetails(data.item)"
            >
              <i class="fa fa-eye"></i>
            </b-button>
          </template>
          <template slot="createdAt" slot-scope="data">
            <div>{{ data.item.createdAt | formatedate }}</div>
          </template>
        </b-table>
        <div class="pagination-div">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="totalRows"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            @change="paginationClick"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </div>
  </div>
</template>
<script>
import VueSimpleSuggest from "vue-simple-suggest";
import ebButton from "@/components/FormElements/Button";
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
import currentUserData from "@/mixins/currentUser";
import { AtomSpinner } from "epic-spinners";
import cDate from "@/components/FormElements/CustomDate.vue";
export default {
  mixins: [currentUserData],
  name: "manageOrder",
  components: {
    ebButton,
    ebSelect,
    VueSimpleSuggest,
    cDate,
    AtomSpinner,
  },
  props: {
    showFilter: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      hideSelect: true,
      showdropdown: false,
      show: false,
      searchInput: "",
      startDate: "",
      fromDate: moment().format("YYYY-MM-DD"),
      disableSellerKey: false,
      endDate: "",
      toDate: moment().format("YYYY-MM-DD"),
      timeRange: "",
      allSellerOptions: [],
      sortBy: "createdAt",
      sortDesc: true,
      selectedDurationOption: {
        text: "Today",
        value: 1,
      },
      durationOptions: [
        {
          text: "Today",
          value: 1,
        },
        {
          text: "7 Days",
          value: 7,
        },
        {
          text: "30 days",
          value: 30,
        },
        {
          text: "Custom",
          value: "custom",
        },
      ],
      searchSellerBy: {
        text: "By Name",
        value: "name",
      },
      searchListOptions: [
        {
          text: "By Name",
          value: "name",
        },
        {
          text: "By Email",
          value: "email",
        },
        {
          text: "By Phone",
          value: "phone",
        },
      ],
      selectedSearchOption: { text: "Search Criteria", value: "" },
      searchOptions: [
        {
          text: "Order Number",
          value: "orderId",
        },
        {
          text: "Seller Name",
          value: "providerName",
        },
        {
          text: "Seller Phone No.",
          value: "providerPhone",
        },
        {
          text: "Seller Email",
          value: "providerEmail",
        },
        {
          text: "Customer Name",
          value: "customerName",
        },
        {
          text: "Customer Phone No.",
          value: "customerPhone",
        },
        {
          text: "Customer Email",
          value: "customerEmail",
        },
        {
          text: "Order Type",
          value: "type",
        },
      ],
      selectedOptionSearch: { text: "Type of order", value: "" },
      searchOrderOptions: [
        {
          text: "Product Order",
          value: "PRODUCT",
        },
        {
          text: "Service Order",
          value: "SERVICE",
        },
        {
          text: "Instore Order",
          value: "INSTORE",
        },
        {
          text: "Merchant Order",
          value: "MERCHANT",
        },
      ],
      //end of order type list

      selectStatusOption: {
        text: "Order Status (All)",
        value: "",
      },
      statusOptions: [
        {
          text: "All",
          value: "",
        },
        {
          text: "Confirmed",
          value: "Confirmed",
        },
        {
          text: "Processing",
          value: "Processing",
        },
        {
          text: "Delivered",
          value: "Delivered",
        },
        {
          text: "Created",
          value: "Created",
        },
        {
          text: "Out For Delivery",
          value: "Out For Delivery",
        },
        {
          text: "Payment Failed",
          value: "Payment Failed",
        },
        {
          text: "Cancelled",
          value: "Cancelled",
        },
        {
          text: "Rejected",
          value: "Rejected",
        },
        {
          text: "Returned",
          value: "Returned",
        },
        {
          text: "Dispatched",
          value: "Dispatched",
        },
        {
          text: "Refund",
          value: "Refund",
        },
        {
          text: "Delivery Attached",
          value: "Delivery Attached",
        },
      ],
      selectedSellerOption: { text: "All Sellers", value: "all" },
      searchQuery: "",
      showDismissibleAlert: false,
      loading: false,
      items: [],
      tableFields: [
        {
          key: "orderId",
          label: "Order#",
          sortable: true,
        },
        {
          key: "createdAt",
          label: "Order Date",
          sortable: true,
        },
        {
          key: "type",
          label: "Order Type",
          sortable: false,
        },
        {
          key: "deliveryAddress.address.fullName",
          label: "Customer Name",
          sortable: false,
        },
        {
          key: "customerPhone",
          label: "Customer Phone",
          sortable: false,
        },
        {
          key: "orderStatus",
          label: "Status",
          sortable: false,
        },
        {
          key: "orderAmount",
          label: "Amount",
          sortable: true,
        },
        {
          key: "deliveryCharges",
          label: "Delivery Charges",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
        },
      ],
      filter: "",
      caption: "Table",
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      tableData: [],
      perPage: 10,
      totalRows: 100,
      currentPage: 1,
      dark: false,
    };
  },
  computed: {
    sellerOptions() {
      if (this.$currentUserData.category == "SELLER") {
        return [
          {
            text: "All Seller",
            value: "all",
          },
          {
            text: "Direct Sellers",
            value: "direct",
          },
        ];
      } else {
        return [
          {
            text: "All Seller",
            value: "all",
          },
          {
            text: "Direct Sellers",
            value: "direct",
          },
          {
            text: "Include Hierarchy",
            value: "include",
          },
        ];
      }
    },
    searchOptionsData() {
      if (this.$currentUserData.category == "SELLER") {
        if (this.selectedSellerOption.value == "direct") {
          return (this.searchOptions = [
            {
              text: "Order Number",
              value: "orderId",
            },
            {
              text: "Customer Name",
              value: "customerName",
            },
            {
              text: "Customer Phone No.",
              value: "customerPhone",
            },
            {
              text: "Customer Email",
              value: "customerEmail",
            },
          ]);
        } else {
          return (this.searchOptions = [
            {
              text: "Order Number",
              value: "orderId",
            },
            {
              text: "Seller Name",
              value: "sellerName",
            },
            {
              text: "Seller Phone No.",
              value: "sellerPhone",
            },
            {
              text: "Seller Email",
              value: "sellerEmail",
            },
            {
              text: "Customer Name",
              value: "customerName",
            },
            {
              text: "Customer Phone No.",
              value: "customerPhone",
            },
            {
              text: "Customer Email",
              value: "customerEmail",
            },
            {
              text: "Order Type",
              value: "type",
            },
          ]);
        }
      } else {
        return this.searchOptions;
      }
    },
    captions() {
      let tableField = this.tableFields;
      tableField.splice(
        3,
        0,
        this.userCategory === "TA" ||
          this.userCategory === "SELLER" ||
          this.userCategory === "DISTRIBUTOR" ||
          this.userCategory === "DEALER" ||
          this.userCategory === "OFFICE"
          ? {
              key: "items[0].providerName",
              label: "Seller Name",
              sortable: false,
            }
          : {
              key: "provider.organization.name",
              label: "Seller Name",
              sortable: false,
            }
      );
      return tableField;
    },
    orderList() {
      let currentUser = JSON.parse(sessionStorage.getItem("userLogin"));
      let listData = [];
      if (currentUser.role === "Tenant") {
        let list = this.$store.getters["order/GetListOrderAllUsers"];
        let regex =
          /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        if (list.length > 0) {
          list.forEach((itemList) => {
            if (
              itemList.customerId &&
              itemList.customerId.authentication &&
              itemList.customerId.authentication.phone
            ) {
              itemList.customerId.authentication.phone = regex.test(
                itemList.customerId.authentication.phone
              )
                ? null
                : itemList.customerId.authentication.phone;
            }
            if (itemList.isMaster) {
              listData.push(itemList);
            }
          });
        }
        this.loading = false;
        let items = listData.filter((el) =>
          el.type
            .toLowerCase()
            .includes(
              this.selectedOptionSearch.value.toLowerCase() == "type"
                ? ""
                : this.selectedOptionSearch.value.toLowerCase()
            )
        );
        return items.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      } else if (currentUser.role === "Partner") {
        let list = [];
        if (this.userCategory === "MANUFACTURER") {
          list = this.$store.getters["order/GetListOrderAllUsers"];
        } else {
          list = this.$store.getters["order/GetListOrderAllUsers"];
        }
        let regex =
          /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
        if (list.length > 0) {
          list.forEach((itemList) => {
            if (
              itemList.customerId &&
              itemList.customerId.authentication &&
              itemList.customerId.authentication.phone
            ) {
              itemList.customerId.authentication.phone = regex.test(
                itemList.customerId.authentication.phone
              )
                ? null
                : itemList.customerId.authentication.phone;
            }
            if (itemList.isMaster) {
              listData.push(itemList);
            }
          });
        }
        this.loading = false;
        return listData.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
      }
    },
    userCategory() {
      return JSON.parse(sessionStorage.getItem("userLogin"))["category"];
    },
  },
  methods: {
    async exportData() {
      this.startDownload();
      let data = [];
      this.disableSellerKey = true;
      let loop = async (page) => {
        let payload = {
          orderStatus: this.selectStatusOption.value,
          fromDate: this.fromDate,
          toDate: this.toDate,
          limit: 500,
          page: page,
        };
        if (this.partnerAllData == null && this.$route.params.id) {
          payload.provider = this.$route.params.id;
        } else {
          payload.provider = this.selectedSellerOption.value;
        }
        if (this.selectedSearchOption.value.length > 0) {
          payload.type = this.selectedSearchOption.value;
          payload.typeVal = this.searchQuery;
        }
        await this.$store
          .dispatch("order/listOrderForAllUsers", payload)
          .then((res) => {
            this.totalRows = res.meta.total > 0 ? res.meta.total : 1;
            res.response.map((obj) => {
              data.push({
                OrderId: obj.orderId,
                OrderDate: moment(String(obj.createdAt)).format(
                  "DD/MM/YYYY hh:mm A"
                ),
                OrderType: obj?.type,
                SellerName: obj?.items[0]?.providerName,
                Address: `${obj?.deliveryAddress?.address?.street1} ${obj?.deliveryAddress?.address?.street2} ${obj?.deliveryAddress?.address?.city} ${obj?.deliveryAddress?.address?.state}, ${obj?.deliveryAddress?.address?.zip} `,
                CustomerName: obj?.deliveryAddress?.address?.fullName,
                CustomerPhone: obj?.customer?.phone,
                Status: obj?.orderStatus,
                Amount: obj?.orderAmount,
                DeliveryCharge: obj?.deliveryCharges,
              });
            });
            this.exportAsCSV(data, "orders");
            this.finishDownload();
          })
          .catch((err) => {
            this.loading = false;
          });
      };
      loop(1);
      if (data.length !== 0) {
        return data;
      }
      this.disableSellerKey = false;
    },
    startDownload() {
      this.$toasted.info("Downloading..");
    },
    finishDownload() {
      this.$toasted.clear();
    },
    getDeliveryContact(data) {
      let phoneList = [];
      if (Array.isArray(data) && data.length > 0) {
        data.forEach((obj) => {
          if (obj.contactType == "PRIMARY_PHONE") {
            phoneList.push(obj.value);
          }
        });
        return phoneList.toString();
      } else {
        ("");
      }
    },
    async paginationClick(e) {
      this.currentPage = e;
      await this.getOrderList();
    },
    async onStatusChange(e) {
      this.selectStatusOption = e;
      this.currentPage = 1;
      this.totalRows = 1;
      await this.getOrderList();
    },
    onSearchChange() {
      if (this.selectedSearchOption.value === "type") {
        this.showdropdown = true;
        this.show = false;
      } else {
        this.show = true;
        this.showdropdown = false;
        if (this.searchQuery != "") {
          this.searchQuery = "";
        }
      }
    },
    viewOrderDetails(data) {
      if (this.$router.history.current.name === "manage-order") {
        this.$router.push({
          name: "manage-order-details",
          params: { orderId: data._id },
        });
      } else {
        this.$router.push({
          name: "manage-order-details",
          params: { orderId: data._id },
        });
      }
    },
    async onSellerChange(data) {
      this.selectedSellerOption = data;
      this.currentPage = 1;
      this.totalRows = 1;
      this.disableSellerKey = true;
      await this.getOrderList();
      this.disableSellerKey = false;
    },

    async searchSpecificSeller(sellerData) {
      if (sellerData && sellerData.length >= 3) {
        this.currentPage = 1;
        this.totalRows = 1;
        this.$store.dispatch("order/cleanOrderList");
        let payload = {
          type: "SELLER",
          key: this.searchSellerBy.value,
          keyVal: this.searchInput,
          includeHierarchy: "y",
        };
        await this.$store.dispatch(
          "partner/listPartnerSearchByNameEmailPhone",
          payload
        );
      }
    },
    async findDateResult(e) {
      this.fromDate = e.fromDate;
      this.toDate = e.toDate;
      this.timeRange = "";
      await this.getOrderList();
    },
    async changeDuration() {
      let e = this.selectedDurationOption;
      if (e.value == "custom") {
        this.hideSelect = false;
        this.$refs["compRefs"].openModal();
        setTimeout(() => {
          this.hideSelect = true;
        }, 30);
        return;
      } else {
        this.fromDate = moment()
          .subtract(e.value - 1, "days")
          .format("YYYY-MM-DD");
        this.toDate = moment().format("YYYY-MM-DD");
        this.startDate = null;
        this.endDate = null;
      }
      await this.getOrderList();
    },
    async getOrderList() {
      this.loading = true;
      this.$store.dispatch("order/cleanOrderList");
      this.disableSellerKey = true;
      let payload = {
        orderStatus: this.selectStatusOption.value,
        fromDate: this.fromDate,
        toDate: this.toDate,
      };
      if (this.partnerAllData == null && this.$route.params.id) {
        payload.provider = this.$route.params.id;
      } else {
        payload.provider = this.selectedSellerOption.value;
      }
      if (this.selectedSearchOption.value.length > 0) {
        payload.type = this.selectedSearchOption.value;
        payload.typeVal = this.searchQuery;
      }
      payload.limit = 10;
      payload.page = this.currentPage;
      await this.$store
        .dispatch("order/listOrderForAllUsers", payload)
        .then((res) => {
          this.totalRows = res.meta.total > 0 ? res.meta.total : 1;
        })
        .catch((err) => {
          this.loading = false;
        });
      this.disableSellerKey = false;
      this.loading = false;
    },
    async reloadData() {
      this.loading = true;
      await this.getOrderList();
      this.loading = false;
    },
    resetFilter() {
      this.loading = true;
      this.selectedSellerOption = { text: "All Sellers", value: "" };
      this.selectedSearchOption = { text: "Search Criteria", value: "" };
      this.selectedOptionSearch = { text: "Type", value: "type" };
      this.searchQuery = "";
      this.getOrderList();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    // this.getOrderList();
    if (this.partnerAllData == null && this.$route.params.id) {
      await this.$store.dispatch(
        "partner/fetchPartnerById",
        this.$route.params.id
      );
    }
    await this.getOrderList();
    await this.changeDuration();
    this.loading = false;
  },
  created() {
    this.timeRange = 1;
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
      }
    },
  },
};
</script>
<style>
.export-btn {
  float: right;
  width: 111%;
}
.dropdown {
  width: 164px;
  font-size: 12px;
  font-weight: 600;
}
.reset {
  color: blue;
  cursor: pointer;
  margin-left: 7px;
  text-decoration: underline;
}
.radius {
  border-radius: 12px;
}
.pagination-div {
  float: right;
  padding: 20px 0px;
}
.custom-control-label::after {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  content: "";
  background: no-repeat 50%/50% 50%;
}
.custom-control-label::before {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #000000 solid 2px;
}
.searchField {
  font-size: 12px;
  font-weight: 600;
  border-radius: 17px;
  padding: 17px;
  height: 36px;
  width: 100%;
  margin-left: 10px;
}
.suggestions {
  position: absolute;
  width: 86%;
  z-index: 2;
  border: 1px solid #cbd3d7;
  border-radius: 4px;
  background-color: #ffffff;
  list-style: none;
  padding: 5px 0px;
  margin: 0px;
  margin-top: 1px;
}
.vue-simple-suggest.designed .input-wrapper input {
  padding-left: 16px;
  background-color: #ffffff;
  border: 1px solid #cbd3d7;
  border-radius: 25px !important;
  height: 36px;
}
.suggest-item {
  padding: 4px 15px;
}
.hover {
  cursor: pointer;
  background-color: #5897fb;
  color: #fff;
}
:focus-visible {
  outline: none;
}
@media (max-width: 768px) {
  .searchField {
    width: 100%;
  }
  .searchIcon {
    width: 100%;
    text-align: center;
  }
  .reset,
  .export-btn {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }
  .pagination-div {
    text-align: center;
  }
}
@media (max-width: 576px) {
  .reset,
  .export-btn {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }
  .pagination-div {
    flex-direction: column;
    align-items: center;
  }
}
</style>
